import ApiNameToUpgradeProductMap from 'self-service-api/constants/ApiNameToUpgradeProductMap';
import { sourceKeys } from '../../_core/common/data/upgradeData/properties/sources';
import { getSource } from '../../_core/common/data/upgradeData/transformers/getPropertySource';
import { track } from '../../_core/common/eventTracking/tracker';
import { getApp } from '../../ums/utils';
export const getDeployableName = () => {
  var _window$hubspot;
  // @ts-expect-error the error notes that bender is not defined on the
  // window.hubspot object, but it's documented in the auth docs:
  // https://product.hubteam.com/docs/product-platform/team-os/user-setup-fe/useful-info.html#how-to-check-which-app-your-looking-at
  return ((_window$hubspot = window.hubspot) === null || _window$hubspot === void 0 || (_window$hubspot = _window$hubspot.bender) === null || _window$hubspot === void 0 ? void 0 : _window$hubspot.currentProject) || getApp();
};
export function getBuyNowUsageTrackingProperties({
  apiNames,
  uniqueBuyNowUseCase,
  screen,
  upgradeReferralSource
}) {
  const app = getDeployableName();
  return {
    apiName: apiNames[0],
    apiNames,
    app,
    checkoutType: 'buy-now',
    screen,
    source: getSource({
      app,
      screen,
      uniqueId: uniqueBuyNowUseCase
    }, sourceKeys.CHECKOUT),
    uniqueId: uniqueBuyNowUseCase,
    upgradeProduct: ApiNameToUpgradeProductMap[apiNames[0]],
    upgradeSource: upgradeReferralSource
  };
}
export const trackViewBuyNowButton = buyNowTrackingProperties => {
  track('checkoutButtonInteraction', Object.assign({
    action: 'viewed'
  }, buyNowTrackingProperties));
};
export const trackClickedBuyNowButton = buyNowTrackingProperties => {
  // Existing view tracker to maintain backwards compatability
  track('checkoutButtonInteraction', Object.assign({
    action: 'clicked'
  }, buyNowTrackingProperties));

  // New tracking event to easily distinguish new buy now flow
  track('checkoutButtonInteraction', Object.assign({
    action: 'clicked checkout anywhere buy now button'
  }, buyNowTrackingProperties));
};
export const trackPurchaseOrderGenerated = buyNowTrackingProperties => {
  track('checkoutButtonInteraction', Object.assign({
    action: 'purchase order generated'
  }, buyNowTrackingProperties));
};
export const trackPurchaseOrderGenerationFailed = buyNowTrackingProperties => {
  track('checkoutButtonInteraction', Object.assign({
    action: 'purchase order generation failed'
  }, buyNowTrackingProperties));
};